import { render, staticRenderFns } from "./TablaGenerica.vue?vue&type=template&id=6f8b0f2f&scoped=true"
import script from "./TablaGenerica.vue?vue&type=script&lang=js"
export * from "./TablaGenerica.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8b0f2f",
  null
  
)

export default component.exports